import morphism, { StrictSchema } from 'morphism'
import { getRequest, urlBuilder } from 'tfs.front-end-utils/requests'

import FlightAllotmentSpacesParameters from '../../interfaces/server/FlightAllotmentSpacesParameters'

import staticData from '../../config/staticData'

import flightIdToAllotmentSpacesParameters from '../../schemas/server/flightIdToAllotmentSpacesParameters'

import formatErrors from '../../utils/errors/formatErrors'
import generateAuthorizationHeaders from '../../utils/requests/generateAuthorizationHeaders'

export default async (flightId: string) => {
  const {
    endpoints: {
      allotments: { url, headers },
    },
  } = staticData
  const authHeaders = await generateAuthorizationHeaders(headers)

  const params = morphism<
    StrictSchema<FlightAllotmentSpacesParameters, string>
  >(flightIdToAllotmentSpacesParameters, flightId)

  const fixedUrl = url.endsWith('/') ? url : `${url}/`
  const reqUrl = `${fixedUrl}allotmentspaces`
  const requestUrl = urlBuilder(reqUrl, params)

  return getRequest(
    requestUrl,
    { headers: { ...headers, ...authHeaders } },
    {},
    formatErrors
  )
}
